import { Box, Paper, Stack, Typography } from "@mui/material";
import React from "react";
import QuickTixWhiteLogo from "../../../../../../Images/GX_Logo_Black_No_Bg.png";
import QrCode from "../../../../../../Images/qrCode1.png";
function Band2({ ticket, ChangeColor, type, image, bookerName, navigator }) {
  const qrCodeData = ticket?.qrCode || "";
  const pevSelected = Number(ticket?.prevTicket) === ticket?.id ? true : false;
  return (
    <Paper
      elevation={0}
      sx={{
        display: "flex",
        border: pevSelected ? "2px solid #4A90E2" : "0px solid #e0e0e0",
        boxShadow: pevSelected
          ? "0 4px 12px rgba(74, 144, 226, 0.5)"
          : "0 8px 8px rgba(0, 0, 0, 0.1)",
        transition: "all 0.3s ease",
        "&:hover": {
          boxShadow: "0 4px 16px rgba(0, 0, 0, 0.2)",
          border: "1px solid #4A90E2",
          borderRadius: "1px",
        },
        backgroundColor: ChangeColor
          ? ChangeColor
          : ticket.bgColor
          ? ticket.bgColor
          : "#00AC4F",
      }}
    >
      <Stack
        flex={1}
        sx={{
          backgroundColor: ChangeColor
            ? ChangeColor
            : ticket.bgColor
            ? ticket.bgColor
            : "#00AC4F",
        }}
        // py={"0.7rem"}
        justifyContent={"center"}
        alignItems={"center"}
        direction={"row"}
      >
        <Stack direction={"row"} alignItems={"center"} gap={0.5}>
          <Box
            sx={{
              textAlign: "center",
              transform: "rotate(90deg)",
              justifyContent: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              height: "100%",
            }}
          >
            <Box>
              {" "}
              {navigator === "ct" ? (
                <></>
              ) : !qrCodeData ? (
                <img
                  src={QrCode}
                  alt="qr"
                  style={{
                    width: "100%",
                    maxWidth: "60%",
                    minWidth: "40px",
                    height: "auto",
                    maxHeight: "40px",
                    objectFit: "contain",
                  }}
                />
              ) : (
                <img
                  src={ticket?.qrCode || QrCode}
                  alt="QR"
                  style={{
                    width: "100%",
                    maxWidth: "80%",
                    height: "auto",
                    maxHeight: "80px",
                    objectFit: "contain",
                  }}
                />
              )}
            </Box>
            <Box>
              {navigator === "ct" ? (
                <></>
              ) : (
                <Typography
                  sx={{ fontSize: "8px", color: "#ffff" }}
                  variant="body1"
                >
                  {ticket?.code ? ticket?.code : "00000000"}
                </Typography>
              )}

              <img
                src={QuickTixWhiteLogo}
                alt=".."
                style={{
                  width: "40%",
                  maxWidth: "80%",
                  height: "auto",
                  maxHeight: "80px",
                  objectFit: "contain",
                  minHeight: "40px",
                }}
              />
            </Box>
          </Box>
        </Stack>
      </Stack>
      <Stack
        flex={{ xs: 1, sm: 1.5 }}
        sx={{
          backgroundColor: "#E8E8E8",
          transform: "skew(30deg)",
        }}
        justifyContent={"center"}
        direction={"row"}
        alignItems={"center"}
        py={"0.3em"}
      >
        <Box>
          <Typography
            variant="h6"
            component="div"
            sx={{
              fontWeight: 400,
              fontSize: { xs: "1.1rem", sm: "2rem" },
              color: "#266331",
              fontFamily: "Bebas Neue",
              transform: "skew(-30deg)", // Negates the skew effect for the text
            }}
            textAlign={"start"}
            ml={1}
          >
            {type ? type : ticket?.type?.[0]?.typeName ?? "VIP"}
          </Typography>
        </Box>
        <Stack direction={"column"} justifyContent={"center"}>
          <Typography
            variant="h6"
            component="div"
            sx={{
              fontWeight: 400,
              fontSize: { xs: "1.1rem", sm: "2rem" },
              color: "#266331",
              fontFamily: "Bebas Neue",
              transform: "skew(-30deg)", // Negates the skew effect for the text
              lineHeight: "1.1em",
            }}
            textAlign={"start"}
            ml={{ xs: 1, sm: 3 }}
          >
            {ticket?.title}
          </Typography>
        </Stack>
      </Stack>
      <Stack
        flex={1}
        sx={{
          backgroundColor: ChangeColor
            ? ChangeColor
            : ticket.bgColor
            ? ticket.bgColor
            : "#00AC4F",
        }}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <img
          src={image ? image : QuickTixWhiteLogo}
          alt=".."
          style={{
            maxWidth: "32%",
            height: "auto",
            maxHeight: "80px",
            minWidth: "40px",
            objectFit: "contain",
            minHeight: "40px",
          }}
        />
        <Typography sx={{ color: "white" }}>
          {ticket?.ticketName ? ticket?.ticketName : "Band"}
        </Typography>
        <Typography
          sx={{
            color: "white",
            marginTop: "5px",
            fontSize: "1rem",
            whiteSpace: "nowrap",
          }}
        >
          ${" "}
          {ticket?.price != null && ticket?.price !== ""
            ? ticket?.ticketPrices
              ? Object.values(ticket?.ticketPrices)[0]
              : Number(ticket?.price) === 0
              ? "Free"
              : Number(ticket?.price) % 1 === 0
              ? Number(ticket?.price).toFixed(0)
              : ticket.price
            : "211"}
        </Typography>
      </Stack>
    </Paper>
  );
}

export default Band2;
